export default __webpack_public_path__ + "static/MyPrivacyNotice-0dd984180a225cd58e4b68e2d872c241.pdf";